import { rankingData } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-500',
  down: 'ri-arrow-down-line text-foreground-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-fire-line text-primary-500 mr-2"></i>
            今日大瓜排行榜
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            实时热度排名，最火的热门大瓜都在这里
          </p>
          <div className="space-y-3">
            {rankingData.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-50 rounded-lg p-4 cursor-pointer hover:bg-primary-50 transition-colors"
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                  item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-foreground-700'
                }`}>
                  <span className="text-sm font-bold">{item.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                    <h3 className="text-sm font-medium text-foreground-800 line-clamp-1">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <i className={`${trendIcons[item.trend]} text-sm`}></i>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}